import useCols from './child.cols';
import useRows from './child.rows';

const useChildLayout = ({ data, pmProvider, isTreeHierarchyEnabled }) => {
  const cols = useCols({ pmProvider, isTreeHierarchyEnabled });
  const rows = useRows({ data, pmProvider, isTreeHierarchyEnabled });
  return { cols, rows };
};

export default useChildLayout;
